function setTheme(theme){
  $('#dark-mode-toggler').find('i').removeClass("ti-moon")
  $('#dark-mode-toggler').find('i').removeClass("ti-moon-off")

  if (theme == "dark") {
    $('#dark-mode-toggler').find('i').addClass("ti-moon")
  } else {
    $('#dark-mode-toggler').find('i').addClass("ti-moon-off")
  }

  localStorage.setItem("theme", theme)
  $("body").attr("data-theme", theme)
}

document.addEventListener("DOMContentLoaded", function(){
  if (localStorage.getItem("theme") == null) {
    localStorage.setItem("theme", "light")
  }

  const theme = localStorage.getItem("theme")
  setTheme(theme)
})

$(document).on("click", "#dark-mode-toggler", function(){
  if (localStorage.getItem("theme") == "light"){
    setTheme("dark")
  } else {
    setTheme("light")
  }
})